import { Component } from '@angular/core';
import { SubmenuModel } from '../layout/submenu/models/submenu.model';
import { SubmenuService } from '../layout/submenu/services/submenu.service';

@Component({
  selector: 'app-seatingchartviewer',
  template: `
    <div class="service-container">
      <div class="submenu" *ngIf="submenuNeeded">
        <app-submenu [serviceTabs]="serviceSubmenuTabs"></app-submenu>
      </div>
      <div class="service-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
})
export class SeatingchartviewerComponent {
  public serviceSubmenuTabs: SubmenuModel;
  public submenuNeeded: boolean;

  constructor(private submenuService: SubmenuService) {
    this.serviceSubmenuTabs = {
      // publicService: {
      //   name: 'Seating Data Viewer',
      //   tabs: [{ title: 'Simulations', path: '/seating-data-viewer/public' }],
      // },
      privateService: {
        name: 'Seating Data Viewer',
        tabs: [{ title: 'Clients', path: '/seating-data-viewer/private/client' }],
      },
    };

    this.submenuNeeded = this.submenuService.isSubmenuNeeded(this.serviceSubmenuTabs);
  }
}
